import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { SaveButton } from '../../../../components/StyledButton';
import Detail from './Detail';
import { ExpenseDetailContext } from './ExpenseDetail';

/**
 * 経費詳細画面 編集モード
 * @returns
 */
const ExpenseDetailEdit: React.FunctionComponent = () => {
  // const { refetch } = useOutletContext<ExpenseDetailContext>();

  // React.useState(() => refetch());

  return (
    <Detail mode="edit">
      <SaveButton />
    </Detail>
  );
};

export default ExpenseDetailEdit;
